<nz-tabset *ngIf="lineCategory.Lines.length !== 0" class="list-section-tabs" nzTabPosition="left" nzType="editable-card"
  [nzSelectedIndex]="selectedIndex" [nzHideAdd]="!this.allowAdd" (nzAdd)="addNewCard()" (nzClose)="deleteCard($event)">
  <nz-tab *ngFor="let line of lineCategory.Lines" [nzTitle]="line.Title"
    [nzClosable]="section.AdditionalInformationParsed.AllowDelete && this.actionType !== 'View'">
    <div nz-row>
      <div nz-col nzXs="24" nzSm="24" nzMd="24"
        [nzLg]="{ span: getSpanVal(fieldKey), push: getPushVal(fieldKey), pull: getPullVal(fieldKey) }"
        [nzXl]="{ span: getSpanVal(fieldKey), push: getPushVal(fieldKey), pull: getPullVal(fieldKey) }"
        *ngFor="let fieldKey of fieldGroupKeys">
        <div *ngFor="let field of fieldGroups[fieldKey]">
          <app-field [moduleStructure]="moduleStructure" [field]="field" [recordModel]="recordModel" [section]="section"
            [lineId]="line.Id" [actionType]="actionType"></app-field>
        </div>
      </div>
    </div>

  </nz-tab>
</nz-tabset>
<nz-empty *ngIf="lineCategory.Lines.length === 0" [nzNotFoundFooter]="footerTpl">

</nz-empty>
<ng-template #footerTpl>
  <button *ngIf="this.allowAdd" nz-button nzType="default" (click)="addNewCard()">
    <i nz-icon nzType="plus" nzTheme="outline"></i> {{'Add new' | locale}}
  </button>
</ng-template>
